/**
 * En enda källa för sajtens publika adress.
 *
 * Regeln: körs vi på .com används live-domänen, körs vi på en Lovable-adress
 * (publicerad eller förhandsvisning) eller lokalt används Lovable-adressen.
 * Så pekar länkar och bilder i mejl alltid på en adress som faktiskt svarar.
 */

/** Adress som används vid test, förhandsvisning och lokal utveckling. */
export const APP_ORIGIN = "https://sweintschool.lovable.app";

/** Kanonisk adress när sajten körs på den riktiga domänen. */
export const LIVE_ORIGIN = "https://sweintschool.com";

/** Översätter ett värdnamn till rätt publik adress. `null` = okänd värd. */
export function originFromHost(host: string | null | undefined): string | null {
  if (!host) return null;
  const name = host.split(":")[0]?.toLowerCase() ?? "";
  if (name === "sweintschool.com" || name === "www.sweintschool.com") return LIVE_ORIGIN;
  if (name.endsWith(".lovable.app")) return APP_ORIGIN;
  return null;
}

declare global {
  // eslint-disable-next-line no-var
  var __SITE_ORIGIN__: string | undefined;
}

/** Sätts en gång per förfrågan i serverentrén (src/server.ts). */
export function setRequestOrigin(host: string | null | undefined): void {
  globalThis.__SITE_ORIGIN__ = originFromHost(host) ?? APP_ORIGIN;
}

/** Adressen som ska användas i länkar, bilder, canonical och mejl just nu. */
export function siteOrigin(): string {
  if (typeof window !== "undefined") {
    return originFromHost(window.location.hostname) ?? APP_ORIGIN;
  }
  if (globalThis.__SITE_ORIGIN__) return globalThis.__SITE_ORIGIN__;
  // Utan förfrågan (schemalagda jobb, rapporter) styr miljöflaggan.
  return process.env["MAIL_ENV"] === "production" ? LIVE_ORIGIN : APP_ORIGIN;
}

/** Gör en relativ sökväg absolut mot aktuell adress. */
export function siteUrl(path = "/"): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${siteOrigin()}${path.startsWith("/") ? path : `/${path}`}`;
}
